import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetJackpotView = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_VIEW_JACKPOT
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetJackpotViewAction({
                    id: data.data.id,
                    name: data.data.label,
                    groups: data.data.groups,
                    jackpot: data.data.jackpot,
                    primary_storage: data.data.primary_storage,
                    secondary_storage: data.data.secondary_storage,
                    min_win: data.data.min_win,
                    max_win: data.data.max_win,
                    min_bet: data.data.min_bet,
                    max_bet: data.data.max_bet,
                    give: data.data.give,
                    visible: data.data.visible,
                    currency: data.data.currency
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetJackpotView as SetGetJackpotView
}